export default class ContaService {
    constructor(http) {
        this._resource = http;
    }

    recoverPassword(email) {
        let body = JSON.stringify(email);
        return this._resource.patch(`usuarios/recoverPassword`, body).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }
    getConta(id_conta) {
        let url = `contas/${id_conta}`;
        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })

    }
    attPrimAcesso(id_conta) {
        let url = `contas/primAcesso/${id_conta}`;
        return this._resource.patch(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })

    }

    relatorio(page, qntdNfe, id_empresa, range, urlFiltros, tipo, idUsuario) {
        let url = `contas/relatorio/${idUsuario}?_page=${page}&_pagesize=${qntdNfe}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success.body;
        }, failed => {
            return failed;
        })
    }



    relatorioDetalhado(idUsuario, conta) {
        let url = `contas/relatorio/${idUsuario}/conta/${conta}`;
        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }

    relatorioContasNotas(idUsuario, conta, mes) {
        let url = `contas/relatorio/${idUsuario}/individual/${conta}/${mes}`;

        return this._resource.get(url).then(success => {
            return success.body;
        }, failed => {
            return failed;
        })
    }

}


// WEBPACK FOOTER //
// ./src/domain/conta/ContaService.js